import React from "react";
import { useTranslation } from "react-i18next";
import { formatFormDateToString } from "go-core/components/Formatters/FormatDate";

interface Props {
	date?: string;
	dateHeader?: string;
	dateSubHeader?: string;
}

const RenderHeaderDate = ({ date, dateSubHeader, dateHeader }: Props) => {
	const { t } = useTranslation();
	return (
		<div className="header-ellipse">
			{date ? (
				<>
					<span className="header">{date ? formatFormDateToString(date)?.getDate() : "0"}</span>
					<span className="sub-header">
						{t(`lib:enums.month_short.${date ? `${new Date(date).getMonth() + 1}` : "1"}`)}
					</span>
				</>
			) : (
				<>
					<span className="header">{dateHeader}</span>
					<span className="sub-header">{dateSubHeader}</span>
				</>
			)}
		</div>
	);
};

export default RenderHeaderDate;
